// extracted by mini-css-extract-plugin
export var colorSquare = "_t0-0";
export var danger = "_t0-5";
export var lightPink = "_t0-8";
export var neutralBlue = "_t0-7";
export var neutralYellow = "_t0-6";
export var normal = "_t0-1";
export var primary = "_t0-2";
export var primaryLight = "_t0-3";
export var solidBlack = "_t0-g";
export var solidGreen = "_t0-b";
export var solidLightBlue = "_t0-d";
export var solidNavy = "_t0-c";
export var solidOrange = "_t0-f";
export var solidPink = "_t0-e";
export var solidRed = "_t0-9";
export var solidYellow = "_t0-a";
export var success = "_t0-4";